var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddImage = function SvgAddImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 3a1 1 0 0 1 1 1v6.768a2.986 2.986 0 0 0-3.634-.283l-.002-.005a1 1 0 0 0-1.728 0l-.738 1.267a1 1 0 0 1-1.736-.014L8.372 8.55a1 1 0 0 0-1.743 0l-2.791 4.96A1 1 0 0 0 4.71 15h5.46q-.142.401-.166.846L10 16l.004.154q.024.445.167.846H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm-4.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
    clipRule: "evenodd"
  })));
};
export default SvgAddImage;